
import Multiselect from 'vue-multiselect';
import { FormError } from '@/types/global';
import Vue from 'vue';
import { getTranslationString } from '~/utility/i18n';

export default Vue.extend({
  components: { Multiselect },
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    placeholder: { type: String, required: true },
    options: { type: Array, required: true },
    initialErrors: {
      type: Array,
      default: () => [],
    },
    errorMessages: { type: Array, default: () => [] },
  },
  data() {
    return {
      optional: process.env.STORYBOOK_ENABLED ? 'optional' : getTranslationString(this.$globals, 'optional'),
      errors: [] as Array<string>,
      selectedValues: [] as Array<any>,
    };
  },
  mounted() {
    if (!process.env.STORYBOOK_ENABLED) {
      window.addEventListener('validateField', (e: Event) => {
        this.validate();
      });
      window.addEventListener('validateForm', (e: Event) => {
        this.validate();
      });
      if (!this.isRequired) {
        this.$el.setAttribute('data-valid', 'true');
      }
    }
    if (this.initialErrors.length) {
      this.errors = (this.initialErrors as Array<string>).map(item => item);
    }
  },
  methods: {
    validate() {
      const errors = [] as Array<string>;
      (this.errorMessages as Array<FormError>).forEach((error: FormError) => {
        if (error.type === 'required') {
          const message = error.message;
          if (!this.selectedValues || this.selectedValues.length === 0) {
            errors.push(message);
          }
        }
      });
      this.errors = errors;
      if (this.errors.length === 0) {
        this.$el.setAttribute('data-valid', 'true');
      } else {
        this.$el.removeAttribute('data-valid');
      }
    },
  },
  computed: {
    isRequired(): Boolean {
      const messages = this.errorMessages as Array<FormError>;
      const requiredError = messages.filter((error: FormError) => error.type === 'required');
      return requiredError.length !== 0;
    },
  },
});
